const $j = (typeof window !== 'undefined' && (window as Window & { $j: unknown }).$j) || (() => {}) as unknown;
const scrolledtop = ((window as Window & { scrolledtop?: number }).scrolledtop ?? 250) as number;
const _sps = ((window as Window & { _sps?: number })._sps ?? 100) as number;

export function nav(): void {
    let fadetime = 250;
    ($j as (s: string) => unknown)('#nav li:not(.blank) a').click(function (e: { preventDefault: () => void }) {
        e.preventDefault();
        const el = ($j as (el: unknown) => unknown)(this);
        const goLink = (el as { attr: (a: string) => string }).attr('href');
        if ((el as { parent: () => { hasClass: (c: string) => boolean } }).parent().hasClass('menu-item-has-children') && (($j as (s: string) => { length: number })('body.oc-open')).length) {
            if ((el as { parent: () => { hasClass: (c: string) => boolean } }).parent().hasClass('open')) {
                (el as { find: (s: string) => { addClass: (c: string) => void; removeClass: (c: string) => void }; next: (s: string) => { stop: (a: boolean, b: boolean) => { slideUp: (n: number, e: string) => void } } }).find('span.fa-minus').addClass('fa-plus').removeClass('fa-minus');
                (el as { next: (s: string) => { stop: (a: boolean, b: boolean) => { slideUp: (n: number, e: string) => void } } }).next('ul').stop(true, false).slideUp(500, 'easeInOutExpo');
            } else {
                (el as { find: (s: string) => { addClass: (c: string) => void; removeClass: (c: string) => void }; next: (s: string) => { stop: (a: boolean, b: boolean) => { slideDown: (n: number, e: string) => void } } }).find('span.fa-plus').addClass('fa-minus').removeClass('fa-plus');
                (el as { next: (s: string) => { stop: (a: boolean, b: boolean) => { slideDown: (n: number, e: string) => void } } }).next('ul').stop(true, false).slideDown(500, 'easeInOutExpo');
                ($j as (s: string) => { next: (s: string) => { stop: (a: boolean, b: boolean) => { slideUp: (n: number, e: string) => void } }; find: (s: string) => { addClass: (c: string) => void; removeClass: (c: string) => void }; removeClass: (c: string) => void })('li.open a').next('ul').stop(true, false).slideUp(500, 'easeInOutExpo');
                ($j as (s: string) => { find: (s: string) => { addClass: (c: string) => void; removeClass: (c: string) => void } })('li.open').find('span.fa-minus').addClass('fa-plus').removeClass('fa-minus');
                ($j as (s: string) => { removeClass: (c: string) => void })('li.open').removeClass('open');
            }
            (el as { parent: () => { toggleClass: (c: string) => void } }).parent().toggleClass('open');
        } else {
            ($j as (s: string) => { removeClass: (c: string) => void })('#nav li.current-menu-item').removeClass('current-menu-item');
            (el as { parent: () => { addClass: (c: string) => void } }).parent().addClass('current-menu-item');
            (el as { addClass: (c: string) => void }).addClass('active');
            ($j as (s: string) => { fadeIn: (n: number) => void })('div.loader, div.home-loader').fadeIn(150);
            fadetime = 250;
            if (!!(($j as (s: string) => { length: number })('body.oc-open')).length) {
                ($j as (s: string) => { fadeOut: (n: number) => void })('#nav, #site-overlay').fadeOut(100);
                ($j as (s: string) => { removeClass: (c: string) => void })('body.oc-open').removeClass('oc-open');
                ($j as (s: string) => { removeClass: (c: string) => void })('.hamburger.is-active').removeClass('is-active');
                ($j as (s: string) => { hide: () => void })('body.home video').hide();
                fadetime = 360;
            }
            setTimeout(() => (document.location.href = goLink), fadetime);
        }
    });
    ($j as (s: string) => { append: (s: string) => void })('li.menu-item-has-children ul>li>a').append('<span class="fa fa-caret-right ddarrow mobile-hide"></span>');
    ($j as (s: string) => { find: (s: string) => { addClass: (c: string) => void; removeClass: (c: string) => void } })('li.current_page_parent>a').find('span.fa-plus').addClass('fa-minus').removeClass('fa-plus');
    ($j as (s: string) => { addClass: (c: string) => void })('li.current_page_parent').addClass('open');
    ($j as (s: string) => { next: (s: string) => { slideDown: (n: number) => void } })('li.current_page_parent a').next('ul').slideDown(10);
    ($j as (s: string) => { click: (fn: () => boolean) => void })('.scrolltop').click(() => {
        (window as Window & { scrollToTop: () => void }).scrollToTop();
        return false;
    });
    ($j as (s: string) => { anchorAnimate: () => void })('.aa').anchorAnimate();
}

(($j as unknown as { fn?: { anchorAnimate: () => void } }).fn ??= {} as { anchorAnimate: () => void }).anchorAnimate = function (this: unknown) {
    return (this as unknown as { each: (fn: (i: number, el: unknown) => void) => unknown }).each(function (_i: number, caller: unknown) {
        ($j as (el: unknown) => unknown)(caller).click(function (e: { preventDefault: () => void }) {
            e.preventDefault();
            const elementClick = ($j as (el: unknown) => unknown)(caller).attr('href');
            const destination = ($j as (s: string) => unknown)(elementClick).offset().top || 0;
            ($j as (s: string) => unknown)('html:not(:animated),body:not(:animated)').animate({ scrollTop: destination }, 1200, 'easeInOutExpo', function () {
                window.location.hash = elementClick;
                ($j as (el: unknown) => unknown)(caller).parent().parent().find('.active').removeClass('active');
                ($j as (el: unknown) => unknown)(caller).parent().addClass('active');
            });
            return false;
        });
    });
};

;(function (_win: Window, $: unknown) {
    const $jq = $ as (arg: string | Document | (() => void) | object) => Record<string, unknown>;
    ($jq as Function)(function () {
        let ripplecover: ReturnType<typeof setTimeout>;
        const doc = $jq(document);
        (doc.on as Function)('click', '.card h2 a ', function () {
            ($jq('body') as Record<string, Function>).addClass('rippling');
            clearTimeout(ripplecover);
            ripplecover = setTimeout(() => ($jq('body') as Record<string, Function>).removeClass('rippling'), 2000);
        });
        (doc.on as Function)('click', '.btn, .ripple, .full-nav a, #nav a, .card h2>a', function (event: MouseEvent) {
            const $div = $jq('<span class="ripple" />') as Record<string, unknown>;
            const btnOffset = ($jq(this) as Record<string, Function>).offset() as { left: number; top: number };
            const xPos = event.pageX - btnOffset.left;
            const yPos = event.pageY - btnOffset.top;
            ($div.addClass as Function)('ripple-effect');
            const $ripple = $jq('.ripple-effect') as Record<string, Function>;
            const el = $jq(this) as Record<string, Function>;
            $ripple.css('height', el.height());
            $ripple.css('width', el.height());
            ($div.css as Function)({ top: yPos - $ripple.height() / 2, left: xPos - $ripple.width() / 2, background: el.data('ripple-color') });
            ($div.appendTo as Function)($jq(this));
            window.setTimeout(() => ($div.remove as Function)?.(), 1400);
        });
    });
})(window, $j);

function scroller(): void {
    const w = $j as (el: unknown) => Record<string, Function>;
    const scrolltop = w(window).scrollTop();
    if (scrolltop > scrolledtop) {
        w('body').addClass('scrolled');
        w('.scrolltop:hidden').stop(true, true).fadeIn();
        w('.scrolltop').addClass('show');
    } else {
        w('body').removeClass('scrolled');
        w('.scrolltop').stop(true, true).fadeOut();
        w('.scrolltop').removeClass('show');
    }
}

(($j as (el: unknown) => Record<string, Function>)(window)).on('scroll', function () {
    clearTimeout((window as Window & { scrollerfn?: ReturnType<typeof setTimeout> }).scrollerfn!);
    (window as Window & { scrollerfn: ReturnType<typeof setTimeout> }).scrollerfn = setTimeout(scroller, _sps);
});
